import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
  colors: {
    primary: '#ff7a00',
    secondary: '#ffd600',
    background: '#181818',
    surface: '#232323',
    card: '#292929',
    text: '#fff',
    textSecondary: '#bdbdbd',
    border: '#333',
    selected: '#ffb74d',
    error: '#ff4b4b',
    success: '#4caf50',
    warning: '#ffc107'
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px'
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '16px',
    xl: '24px'
  }
};

export default theme; 